import React, { useEffect, useState } from 'react'
import MessageList from '@/components/chat/MessageList'
import ChatInput from '@/components/chat/ChatInput'
import SuggestedTopics from '@/components/chat/SuggestedTopics'

import { useChatStore } from '../chatStore'
import { useCustomChat } from '../useCustomChat'

const mockMentions = [
  { id: 'p1', type: 'product', name: 'User Analytics Dashboard' },
  { id: 'p2', type: 'product', name: 'Mobile App' },
  { id: 'p3', type: 'product', name: 'Payment Gateway' },
  { id: 'pr1', type: 'project', name: 'Q4 Product Launch' },
  { id: 'pr2', type: 'project', name: 'UX Redesign' },
  { id: 'pr3', type: 'project', name: 'Performance Optimization' },
]

const suggestedTopics = [
  { id: 't1', text: 'Identify key personas & user types' },
  { id: 't2', text: 'Describe our users typical day' },
  { id: 't3', text: 'Name users top pain points' },
  { id: 't4', text: 'List recent feature requests' },
]

type MessageType = {
  id: string
  role: 'user' | 'assistant'
  content: string
  timestamp: Date
  isLoading?: boolean
  mentions?: Array<{ id: string; type: string; name: string }>
}

type Mention = {
  id: string
  type: string
  name: string
}

export default function Chat({
  threadId,
  initialMessages,
}: {
  threadId: string
  isDarkMode: boolean
  initialMessages: MessageType[]
  isLoading: boolean
}) {
  console.log('-- initialMessages', initialMessages)

  const { append, messages } = useCustomChat({
    id: threadId,
    initialMessages,
  })
  const [input, setInput] = useState('')
  const [isProcessing] = useState(false)
  const [showMentions, setShowMentions] = useState(false)
  const [mentionQuery] = useState('')
  const [mentionPosition] = useState(0)
  const [selectedMentions, setSelectedMentions] = useState<Mention[]>([])
  const [filteredMentions] = useState(mockMentions)

  const { threads } = useChatStore()

  const showSuggestions = messages.length === 0

  const currentThread = threads.find((thread) => thread.id === threadId)

  console.log('currentThread --', currentThread)

  const handleMentionSelect = (mention: Mention) => {
    const beforeMention = input.substring(0, mentionPosition)
    const afterMention = input.substring(mentionPosition + mentionQuery.length + 1)

    const newInput = `${beforeMention}@${mention.name} ${afterMention}`
    setInput(newInput)
    setShowMentions(false)
    setSelectedMentions([...selectedMentions, mention])
  }

  useEffect(() => {
    const newChatInput = localStorage.getItem('newChatInput')
    if (newChatInput) {
      append({
        role: 'user',
        content: newChatInput,
      })
      localStorage.removeItem('newChatInput')
    }
  }, [])

  const handleSelectTopic = (topic: string) => {
    append({
      role: 'user',
      content: topic,
    })
  }

  console.log('messages --', messages)

  return (
    <div className="flex-1 flex flex-col h-full">
      {/* Let MessageList handle its own scrolling to avoid nested scroll containers */}
      <MessageList messages={messages} />

      <div className="mt-auto">
        {showSuggestions && (
          <div className="px-10 mb-4">
            <SuggestedTopics topics={suggestedTopics} onSelectTopic={handleSelectTopic} />
          </div>
        )}

        <ChatInput
          currentThreadId={threadId}
          input={input}
          isProcessing={isProcessing}
          showMentions={showMentions}
          filteredMentions={filteredMentions}
          onMentionSelect={handleMentionSelect}
        />
      </div>
    </div>
  )
}
